import { render, staticRenderFns } from "./TaskAttachments.vue?vue&type=template&id=ec3fd3f2&"
import script from "./TaskAttachments.vue?vue&type=script&lang=js&"
export * from "./TaskAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports